module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.routes), function(item) {
    return _c('div', {
      key: item.id
    }, [(!item.hidden && item.noDropdown) ? _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path
      }
    }, [(item.icon) ? _c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('wscn-icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n            ")], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('div', {
        key: child.id
      }, [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                        " + _vm._s(child.name) + "\n                    ")])], 1)], 1) : _vm._e()
    })], 2) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e937762"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 290
// module chunks = 25